var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_639_08160"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_639_08160)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,8.75C25,8.75,25,26.25,25,26.25C25,26.5815,24.8682,26.8995,24.6339,27.1339C24.3995,27.3682,24.0815,27.5,23.75,27.5C23.75,27.5,6.25,27.5,6.25,27.5C5.918480000000001,27.5,5.6005400000000005,27.3682,5.36611,27.1339C5.1317,26.8995,5,26.5815,5,26.25C5,26.25,5,8.75,5,8.75C5,8.75,2.5,8.75,2.5,8.75C2.5,8.75,2.5,6.25,2.5,6.25C2.5,6.25,27.5,6.25,27.5,6.25C27.5,6.25,27.5,8.75,27.5,8.75C27.5,8.75,25,8.75,25,8.75C25,8.75,25,8.75,25,8.75ZM7.5,8.75C7.5,8.75,7.5,25,7.5,25C7.5,25,22.5,25,22.5,25C22.5,25,22.5,8.75,22.5,8.75C22.5,8.75,7.5,8.75,7.5,8.75C7.5,8.75,7.5,8.75,7.5,8.75ZM8.75,2.5C8.75,2.5,21.25,2.5,21.25,2.5C21.25,2.5,21.25,5,21.25,5C21.25,5,8.75,5,8.75,5C8.75,5,8.75,2.5,8.75,2.5C8.75,2.5,8.75,2.5,8.75,2.5ZM13.75,12.5C13.75,12.5,16.25,12.5,16.25,12.5C16.25,12.5,16.25,21.25,16.25,21.25C16.25,21.25,13.75,21.25,13.75,21.25C13.75,21.25,13.75,12.5,13.75,12.5C13.75,12.5,13.75,12.5,13.75,12.5Z",
    fill: "#27314D",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.826d14c7d33c6f60ca1df15f3d03d9e4.svg";
export { ForwardRef as ReactComponent };